import React, { Component } from 'react'
import { Provider } from 'react-redux'
import { compose, createStore } from 'redux'

import ApplicationContainer from './ApplicationContainer'
import applicationReducers from './reducers/application'

// eslint-disable-next-line no-underscore-dangle
const composeWithEnhancers = global.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const applicationStore = createStore(
  applicationReducers,
  composeWithEnhancers(),
)

/* eslint-disable react/prefer-stateless-function */
class ApplicationProvider extends Component {
  render() {
    return (
      <Provider store={applicationStore}>
        <ApplicationContainer />
      </Provider>
    )
  }
}
/* eslint-enable */

export default ApplicationProvider



// WEBPACK FOOTER //
// ./src/ApplicationProvider.js